module.exports = __webpack_public_path__ + "static/img/nodata.4a4520c3.png";